import { Box, BoxProps } from "@chakra-ui/react";
import {
    RichText as JssRichText,
    RichTextField,
    useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import HtmlReactParser from "components/HtmlReactParser";

interface SCTextProps extends BoxProps {
    richTextField?: RichTextField;
}

const SCRichText = ({ richTextField, ...props }: SCTextProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    if (!richTextField) return null;

    if (!pageEditing && richTextField?.value) {
        return (
            <Box {...props} className={"richtext"}>
                <HtmlReactParser html={richTextField.value} />
            </Box>
        );
    } else if (pageEditing) {
        return (
            <Box className="richtext">
                <JssRichText field={richTextField} />
            </Box>
        );
    }

    return null;
};

export default SCRichText;
